<ng-container [formGroup]="form">
<div class="card" >
  <!-- start header container -->
  <div class="card-header-container">
    <app-chart-card-default-header
    [title]="title"
    [showReloadButton]="showReloadButton"
    [showFiltersButton]="showFiltersButton"
    [filterSearchKey]="filterSearchKey"
    (refreshChartEvent)="onRefresh($event)"
    [showFiltersSearchButton]="showFiltersSearchButton">
      <ng-template header-data [ngTemplateOutlet]="headerTemplate" [ngTemplateOutletContext]="{$implicit : contentData}"></ng-template>
      <ng-template filters [ngTemplateOutlet]="filterTemplate"></ng-template>
    </app-chart-card-default-header>
    </div>
    <!-- end header container -->
  <div class="card-content" [style.height]="contentHeight">
    <ng-template [ngTemplateOutlet]="contentTemplate" [ngTemplateOutletContext]="{$implicit : contentData}"></ng-template>
  </div>
  <!-- start loading spinner -->
  <ng-container *ngIf="showLoading">
    <div class="loading" >
      <app-spinner></app-spinner>
    </div>
  </ng-container>
  <!-- end loading spinner -->
</div>

</ng-container>
